import { Flex, styled } from '@withjoy/joykit';
import { Link } from '@shared/core/router.helper/reactRouter';

export const Wrapper = styled(Link)`
  display: flex;
  padding: 0.875rem 1rem;
  margin-bottom: 1rem;
  border: 1px solid ${({ theme }) => theme.colors.mono3};
  gap: 0.75rem;
  border-radius: 0.5rem;
  max-width: 24.688rem;
  transition: background-color 0.2s, outline 0.2s, color 0.2s, opacity 0.2s, border 0.2s;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.mono2};
  }
  &:active {
    background-color: ${({ theme }) => theme.colors.mono5};
  }
  &:focus {
    outline: none;
    border: 1px solid ${({ theme }) => theme.colors.purple7};
    box-shadow: inset 0 0 0 1px ${({ theme }) => theme.colors.purple7};
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.sm2}) {
    flex-direction: column;
    width: 100%;
    min-height: 8.313rem;
    gap: 1rem;
  }
`;

export const Information = styled(Flex)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  text-align: left;
`;

export const CTAButton = styled(Flex)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  text-align: left;
`;

export const IconWrapper = styled(Flex)`
  height: 100%;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  @media (max-width: ${({ theme }) => theme.breakpoints.sm2}) {
    display: none;
  }
`;
